var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "-8 0 20 20",
    id: "meteor-icon-kit__regular-ellipsis-v",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.89543 0.8954 0 2 0C3.1046 0 4 0.89543 4 2C4 3.10457 3.1046 4 2 4C0.8954 4 0 3.10457 0 2zM0 10C0 8.8954 0.8954 8 2 8C3.1046 8 4 8.8954 4 10C4 11.1046 3.1046 12 2 12C0.8954 12 0 11.1046 0 10zM0 18C0 16.8954 0.8954 16 2 16C3.1046 16 4 16.8954 4 18C4 19.1046 3.1046 20 2 20C0.8954 20 0 19.1046 0 18z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.9fe0986ea871cf966de95cf9d5bb4acb.svg";
export { ForwardRef as ReactComponent };